export const columnsMeters = [
	{
		headerName: 'Наименование счётчика',
		field: 'name',
		input: true,
		width: 250,
	},
	{
		headerName: 'Тариф',
		field: 'values',
		width: 150,
		sort: true,
	},
	{
		headerName: 'Разрядность',
		field: 'capacity',
		width: 150,
		sort: true,
	},
	{
		headerName: 'Сервис',
		field: 'service',
		input: true,
		width: 250,
	},
	{
		headerName: 'Последнее обновление',
		field: 'date',
		width: 250,
		sort: true,
	},
	{
		headerName: 'Номер л/с',
		field: 'acc_id',
		input: true,
		width: 150,
	},
	{
		headerName: 'Показания 1',
		field: 'val1',
		width: 150,
		sort: true,
	},
	{
		headerName: 'Показания 2',
		field: 'val2',
		width: 150,
		sort: true,
	},
	{
		headerName: 'Показания 3',
		field: 'val3',
		width: 150,
		sort: true,
	},
	{
		headerName: 'От жильца',
		field: 'from_phone',
		width: 150,
		sort: true,
	},
];
